import React from "react";
import ProfileImage from "../images/profileImages/ProfileImage";

const CommentTextInput = ({className, profilePictureUrl, placeholderText, commentString, setCommentString}: {className?: string, profilePictureUrl: string, placeholderText: string, commentString: string, setCommentString: (comment: string) => void}) => {

    return (
        <div className={`comment-text-input-wrapper ${className ?? ""} `}>
            <label htmlFor="comment-input" className="sr-only">
                Add a comment
            </label>

            <ProfileImage profileImageUrl={profilePictureUrl} />
         
            <input
                type="text"
                id="comment-input"
                className="comment-input"
                placeholder={placeholderText}
                value={commentString}
                onChange={(e) => setCommentString(e.target.value)}
                aria-label="Input Comment Text"
            />
        </div>
    );
};

export default CommentTextInput